var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgJewelry = function SvgJewelry(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m32.773 15.973-3.782 2.84a11.08 11.08 0 0 1 5.676 9.631c0 6.125-4.987 11.112-11.111 11.112s-11.112-4.987-11.112-11.112c0-4.142 2.307-7.72 5.676-9.63l-3.782-2.84A15.49 15.49 0 0 0 8 28.443a15.556 15.556 0 0 0 31.111 0 15.49 15.49 0 0 0-6.338-12.47m-.329-5.306L28 4h-8.889l-4.444 6.667 8.889 6.666z"
  })));
};
export default SvgJewelry;